<div class="pb-header-home p-0" [class.container-fluid]="module?.width == 'FULL'"
    [class.container]="module?.width == 'CONSTRAINED'" style="overflow: hidden">
    <div class="row p-0">
        <div class="col-12 text-white p-0">
            <swiper [slidesPerView]="1" [effect]="'fade'" [autoplay]="{ delay: 5000 }" [speed]="1500" [spaceBetween]="0"
                class="w-100 home-swiper">
                <ng-template swiperSlide class="w-100" *ngFor="let slide of slides">

                    <div class="d-block d-sm-block d-md-none w-100 header-home-bg-mobile"
                        [style.padding-top.px]="module?.padding_top" [style.padding-bottom.px]="module?.padding_bottom">

                        <img class="slide-background" src="{{ slide?.content?.image_mobile }}" alt="{{ slide?.content?.alt }}">

                        <!--<h1 class="text-center">{{ slide?.content?.title }}</h1>-->
                        <h1 class="text-center" [innerHTML]="slide?.content?.title | safeHtml"></h1>

                        <div class="d-block mx-auto text-white text-center"
                            style="max-width: 700px; padding-left: 60px; padding-right: 60px;"
                            [ngClass]="slide?.alignment">
                            <p class="mt-0">{{ slide?.content?.description }}</p>
                        </div>

                        <p class="text-center" *ngIf="slide?.content?.link_text">
                            <a routerLink="{{ slide?.content?.link }}">
                                <button type="button" class="btn border-white rounded-pill text-white btn-lg font-size-16 mt-4 border-2">
                                    {{ slide?.content?.link_text }} <!--<img loading="lazy" src="assets/img/icons/icn-arrow-forward.svg" />-->
                                    <!--<i class="material-symbols-outlined text-white">east</i>-->
                                    <mat-icon aria-hidden="false" aria-label="go">east</mat-icon>
                                </button>
                            </a>
                        </p>
                    </div>

                    <div class="d-none d-sm-none d-md-block w-100 header-home-bg"
                        [style.padding-top.px]="module?.padding_top" [style.padding-bottom.px]="module?.padding_bottom">

                        <img class="slide-background" src="{{ slide?.content?.image }}" alt="{{ slide?.content?.alt }}">

                        <div class="container">
                            <!--<h1 class="text-center">{{ slide?.content?.title }}</h1>-->
                            <h1 class="text-center text-lg-left" [innerHTML]="slide?.content?.title | safeHtml"></h1>

                            <div class="d-block me-auto text-white text-center text-lg-left pt-3" style="max-width: 700px;"
                                [ngClass]="slide?.alignment">
                                <p class="mt-0">{{ slide?.content?.description }}</p>
                            </div>

                            <ng-container *ngIf="slide?.content?.link?.includes('http')">
                                <p class="text-center text-lg-left" *ngIf="slide?.content?.link_text">
                                    <a target="{{ slide?.content?.link }}" target="_blank">
                                        <button type="button"
                                            class="btn border-white rounded-pill text-white btn-lg font-size-16 mt-4 border-2">
                                            {{ slide?.content?.link_text }} <!--<img src="assets/img/icons/icn-arrow-forward.svg" />-->
                                            <i class="material-symbols-outlined text-white">east</i>
                                        </button>
                                    </a>
                                </p>
                            </ng-container>

                            <ng-container *ngIf="!slide?.content?.link?.includes('http')">
                                <p class="text-center text-lg-left" *ngIf="slide?.content?.link_text">
                                    <a routerLink="{{ slide?.content?.link }}">
                                        <button type="button"
                                            class="btn border-white rounded-pill text-white btn-lg font-size-16 mt-4 border-2">
                                            {{ slide?.content?.link_text }} <!--<img src="assets/img/icons/icn-arrow-forward.svg" />-->
                                            <i class="material-symbols-outlined text-white">east</i>
                                        </button>
                                    </a>
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>
</div>
